import { isString as o, isNumber as t, isBoolean as i } from "../../utils/types.js";
const r = {
  modelValue: {
    type: [Boolean, Number, String],
    default: () => {
    }
  },
  name: {
    type: String,
    default: void 0
  },
  label: {
    type: [String, Boolean, Number, Object]
  },
  size: {
    type: String
  },
  disabled: Boolean,
  checked: Boolean,
  tabindex: [String, Number]
}, a = {
  change: (e) => o(e) || t(e) || i(e),
  "update:modelValue": (e) => o(e) || t(e) || i(e)
};
export {
  a as checkboxEmits,
  r as checkboxProps
};
